import { IndustryVertical } from "@safetyculture/s12-apis-connect-web/s12/accounts/v1/industry_vertical_pb";

export interface IndustryVerticalOption {
  value: IndustryVertical;
  label: string;
}

// UNSPECIFIED intentionally excluded — internal sentinel, not user-selectable.
export const industryVerticals: IndustryVerticalOption[] = [
  { value: IndustryVertical.QSR, label: "QSR" },
  { value: IndustryVertical.MANUFACTURING, label: "Manufacturing" },
  { value: IndustryVertical.CONSTRUCTION, label: "Construction" },
  { value: IndustryVertical.RETAIL, label: "Retail" },
  { value: IndustryVertical.HOSPITALITY, label: "Hospitality" },
  {
    value: IndustryVertical.ENERGY_UTILITIES_WASTE,
    label: "Energy, Utilities & Waste",
  },
  { value: IndustryVertical.TRANSPORTATION, label: "Transportation" },
  { value: IndustryVertical.MINERALS_MINING, label: "Minerals & Mining" },
  {
    value: IndustryVertical.PROPERTY_FACILITIES_MANAGEMENT,
    label: "Property & Facilities Management",
  },
  {
    value: IndustryVertical.PROFESSIONAL_SERVICES,
    label: "Professional Services",
  },
  { value: IndustryVertical.HEALTHCARE, label: "Healthcare" },
  { value: IndustryVertical.EDUCATION, label: "Education" },
  { value: IndustryVertical.AGRICULTURE, label: "Agriculture" },
  {
    value: IndustryVertical.TELECOMMUNICATIONS_MEDIA,
    label: "Telecommunications & Media",
  },
  { value: IndustryVertical.FINANCE_INSURANCE, label: "Finance & Insurance" },
  { value: IndustryVertical.OTHER, label: "Other" },
];

// Mirrors api-tools-support's industryVerticalToStoredString map (internal/api/org_industry_vertical.go) —
// the setting is persisted as this string, not the enum's TS key name.
export const industryVerticalByStoredName: Record<string, IndustryVertical> = {
  QSR: IndustryVertical.QSR,
  Manufacturing: IndustryVertical.MANUFACTURING,
  Construction: IndustryVertical.CONSTRUCTION,
  Retail: IndustryVertical.RETAIL,
  Hospitality: IndustryVertical.HOSPITALITY,
  EnergyUtilitiesWaste: IndustryVertical.ENERGY_UTILITIES_WASTE,
  Transportation: IndustryVertical.TRANSPORTATION,
  MineralsMining: IndustryVertical.MINERALS_MINING,
  PropertyFacilitiesManagement: IndustryVertical.PROPERTY_FACILITIES_MANAGEMENT,
  ProfessionalServices: IndustryVertical.PROFESSIONAL_SERVICES,
  Healthcare: IndustryVertical.HEALTHCARE,
  Education: IndustryVertical.EDUCATION,
  Agriculture: IndustryVertical.AGRICULTURE,
  TelecommunicationsMedia: IndustryVertical.TELECOMMUNICATIONS_MEDIA,
  FinanceInsurance: IndustryVertical.FINANCE_INSURANCE,
  Other: IndustryVertical.OTHER,
};
